// src/styles/css-variables.ts
import { css } from "lit";
var largeSpacingOnMd = css`
  @media (width >= 960px) {
    * {
      --spacing-sm: 24px;
      --spacing-m: 32px;
      --spacing-lm: 36px;
      --spacing-l: 40px;
      --spacing-xl: 48px;
      --spacing-2xl: 64px;
      --spacing-3xl: 72px;
      --spacing-4xl: 144px;
    }
  }
`;

export {
  largeSpacingOnMd
};
